<div class="chart-container">
  <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" [(update)]="updateFlag">
  </highcharts-chart>
</div>
